import { startClient } from "./runtime/session-runtime";
import "./runtime/auth-gate.css";
import { requireBianhuaSession } from "./runtime/auth-gate";

// URL-controlled visual fixtures must never become a production transport.
const visualDemoAllowed = import.meta.env.DEV || import.meta.env.MODE === "test";
Object.defineProperty(window, "BianhuaVisualDemoAllowed", {
  configurable: false,
  enumerable: false,
  writable: false,
  value: visualDemoAllowed,
});

const gatewayUrl = import.meta.env.VITE_BIANHUA_GATEWAY_URL?.trim();
const authUrl = import.meta.env.VITE_BIANHUA_AUTH_URL?.trim();
const mediaUrl = import.meta.env.VITE_BIANHUA_MEDIA_URL?.trim();
const artifactHosts = String(import.meta.env.VITE_BIANHUA_ARTIFACT_HOSTS || "").split(",").map((host: string) => host.trim()).filter(Boolean);
if (gatewayUrl && !window.BianhuaRuntimeConfig?.gatewayUrl) {
  window.BianhuaRuntimeConfig = { ...window.BianhuaRuntimeConfig, gatewayUrl };
}
if (artifactHosts?.length && !window.BianhuaRuntimeConfig?.artifactHosts) {
  window.BianhuaRuntimeConfig = { ...window.BianhuaRuntimeConfig, artifactHosts };
}
if (mediaUrl && !window.BianhuaRemoteConfig?.url) {
  window.BianhuaRemoteConfig = { ...window.BianhuaRemoteConfig, url: mediaUrl };
}

const { startClientUpdateChecks } = await import("./runtime/client-update");
startClientUpdateChecks();

await requireBianhuaSession({
  ...(authUrl ? { authUrl } : {}),
  ...(gatewayUrl ? { gatewayUrl } : {}),
  testBypass: import.meta.env.MODE === "test",
});

await import("./remote-transport.js");
const bootstrapParams = new URLSearchParams(location.search);
if (visualDemoAllowed && bootstrapParams.get("media") === "demo") await import("./remote-transport.mock.js");
// @ts-expect-error Legacy V7 side-effect script intentionally has no exports.
await import("./app.js");
// @ts-expect-error Legacy V7 side-effect script intentionally has no exports.
await import("./media-bridge.js");
await startClient();
document.documentElement.dataset.clientState = visualDemoAllowed
  && (bootstrapParams.get("capture") === "1" || bootstrapParams.get("media") === "demo")
  ? "demo"
  : "runtime";
